export default "__VITE_ASSET__B$ezvTCw__"